import {
  LayoutDashboard, Building2, Building, Users, ShieldCheck, KeyRound, CreditCard,
  Package, Boxes, Puzzle, ToggleRight, Gauge, Factory, Palette, FlaskConical,
  Handshake, Store, Settings, ScrollText, Activity, LineChart,
  Bell, FolderOpen, BrainCircuit, Contact, UserRound, Sparkles, PieChart,
  Target, UserPlus, Radio, TrendingUp, Columns3, PhoneCall, ListChecks,
  Inbox, Headset, MessageSquareText, Split,
  LifeBuoy, Ticket, FolderKanban, Timer, Star,
  Megaphone, Send,
  BookOpen, FileText, HelpCircle, FolderArchive, Search, FolderTree, Tags,
  Bot, Lightbulb,
  Cable, Plug, RefreshCw, TriangleAlert,
  Crown, Radar, Crosshair, BarChart3, HeartPulse, Receipt, Globe,
  Gift, Award, Wallet, Coins,
} from "lucide-react";

// Each item: { label, to, icon, perm }
export const NAV_GROUPS = [
  {
    group: "Overview",
    items: [
      { label: "Dashboard", to: "/admin/dashboard", icon: LayoutDashboard, perm: "DASHBOARD.VIEW" },
      { label: "Commercial Center", to: "/admin/commercial", icon: LineChart, perm: "DASHBOARD.VIEW" },
      { label: "Platform Monitoring", to: "/admin/monitoring", icon: Activity, perm: "MONITORING.VIEW" },
    ],
  },
  {
    group: "Customer 360",
    items: [
      { label: "Customer 360", to: "/admin/customer-360", icon: Sparkles, perm: "CUSTOMER.VIEW" },
      { label: "Customers", to: "/admin/customers", icon: Contact, perm: "CUSTOMER.VIEW" },
      { label: "Contacts", to: "/admin/contacts", icon: UserRound, perm: "CONTACT.VIEW" },
      { label: "Segments", to: "/admin/segments", icon: PieChart, perm: "SEGMENT.VIEW" },
    ],
  },
  {
    group: "CRM",
    items: [
      { label: "CRM Dashboard", to: "/admin/crm", icon: Target, perm: "LEAD.VIEW" },
      { label: "Leads", to: "/admin/leads", icon: UserPlus, perm: "LEAD.VIEW" },
      { label: "Lead Sources", to: "/admin/lead-sources", icon: Radio, perm: "LEAD_SOURCE.VIEW" },
      { label: "Opportunities", to: "/admin/opportunities", icon: TrendingUp, perm: "OPPORTUNITY.VIEW" },
      { label: "Pipeline", to: "/admin/pipeline", icon: Columns3, perm: "OPPORTUNITY.VIEW" },
      { label: "Sales Activities", to: "/admin/sales-activities", icon: PhoneCall, perm: "SALES_ACTIVITY.VIEW" },
      { label: "Tasks & Follow-ups", to: "/admin/tasks", icon: ListChecks, perm: "TASK.VIEW" },
      { label: "Sales Forecast", to: "/admin/forecast", icon: LineChart, perm: "OPPORTUNITY.VIEW" },
    ],
  },
  {
    group: "Inbox",
    items: [
      { label: "Unified Inbox", to: "/admin/inbox", icon: Inbox, perm: "CONVERSATION.VIEW" },
      { label: "Supervisor View", to: "/admin/inbox/supervisor", icon: Headset, perm: "INBOX.SUPERVISE" },
      { label: "Channels", to: "/admin/channels", icon: Radio, perm: "CHANNEL.VIEW" },
      { label: "Message Templates", to: "/admin/comm-templates", icon: MessageSquareText, perm: "COMM_TEMPLATE.VIEW" },
      { label: "Routing Rules", to: "/admin/routing-rules", icon: Split, perm: "ROUTING.VIEW" },
    ],
  },
  {
    group: "Service",
    items: [
      { label: "Service Dashboard", to: "/admin/service", icon: LifeBuoy, perm: "TICKET.VIEW" },
      { label: "Tickets", to: "/admin/tickets", icon: Ticket, perm: "TICKET.VIEW" },
      { label: "Cases", to: "/admin/cases", icon: FolderKanban, perm: "CASE.VIEW" },
      { label: "SLA Policies", to: "/admin/sla-policies", icon: Timer, perm: "SLA.VIEW" },
      { label: "Escalation Matrix", to: "/admin/escalation-rules", icon: TrendingUp, perm: "ESCALATION.VIEW" },
      { label: "Customer Feedback", to: "/admin/feedback", icon: Star, perm: "FEEDBACK.VIEW" },
    ],
  },
  {
    group: "Campaigns",
    items: [
      { label: "Campaign Dashboard", to: "/admin/campaigns", icon: Megaphone, perm: "CAMPAIGN.VIEW" },
      { label: "Campaigns", to: "/admin/campaigns/list", icon: Send, perm: "CAMPAIGN.VIEW" },
    ],
  },
  {
    group: "Knowledge",
    items: [
      { label: "Knowledge Dashboard", to: "/admin/knowledge", icon: BookOpen, perm: "KNOWLEDGE.VIEW" },
      { label: "Articles", to: "/admin/knowledge/articles", icon: FileText, perm: "KNOWLEDGE.VIEW" },
      { label: "FAQs", to: "/admin/knowledge/faqs", icon: HelpCircle, perm: "KNOWLEDGE.VIEW" },
      { label: "Policy Documents", to: "/admin/knowledge/documents", icon: FolderArchive, perm: "KNOWLEDGE.VIEW" },
      { label: "Knowledge Search", to: "/admin/knowledge/search", icon: Search, perm: "KNOWLEDGE.VIEW" },
      { label: "Categories", to: "/admin/knowledge/categories", icon: FolderTree, perm: "KNOWLEDGE.VIEW" },
      { label: "Tags", to: "/admin/knowledge/tags", icon: Tags, perm: "KNOWLEDGE.VIEW" },
    ],
  },
  {
    group: "Executive",
    items: [
      { label: "Command Center", to: "/admin/exec/ceo", icon: Crown, perm: "EXEC.CEO" },
      { label: "Sales Leadership", to: "/admin/exec/sales", icon: TrendingUp, perm: "EXEC.SALES" },
      { label: "Marketing Leadership", to: "/admin/exec/marketing", icon: Megaphone, perm: "EXEC.MARKETING" },
      { label: "Service Leadership", to: "/admin/exec/service", icon: LifeBuoy, perm: "EXEC.SERVICE" },
      { label: "Collections", to: "/admin/exec/collections", icon: Receipt, perm: "EXEC.COLLECTIONS" },
      { label: "Customer Risk Radar", to: "/admin/exec/risk-radar", icon: Radar, perm: "EXEC.VIEW" },
      { label: "Opportunity Radar", to: "/admin/exec/opportunity-radar", icon: Crosshair, perm: "EXEC.SALES" },
      { label: "Campaign Performance", to: "/admin/exec/campaign-summary", icon: BarChart3, perm: "EXEC.MARKETING" },
      { label: "Customer Health", to: "/admin/exec/customer-health", icon: HeartPulse, perm: "EXEC.VIEW" },
    ],
  },
  {
    group: "AI Copilot",
    items: [
      { label: "AI Copilot", to: "/admin/ai/copilot", icon: Sparkles, perm: "AI.USE" },
      { label: "AI Audit Log", to: "/admin/ai/audit", icon: ScrollText, perm: "AI.AUDIT" },
    ],
  },
  {
    group: "AI Agents",
    items: [
      { label: "Agent Center", to: "/admin/agents", icon: Bot, perm: "AI_AGENT.VIEW" },
      { label: "Recommendations", to: "/admin/agents/recommendations", icon: Lightbulb, perm: "AI_AGENT.VIEW" },
      { label: "Approvals", to: "/admin/agents/approvals", icon: ShieldCheck, perm: "AI_AGENT.VIEW" },
      { label: "Agent Audit", to: "/admin/agents/audit", icon: ScrollText, perm: "AI_AGENT.VIEW" },
    ],
  },
  {
    group: "Integration Fabric",
    items: [
      { label: "Integration Hub", to: "/admin/integrations", icon: Cable, perm: "INTEGRATION.VIEW" },
      { label: "Connectors", to: "/admin/integrations/connectors", icon: Plug, perm: "INTEGRATION.VIEW" },
      { label: "Integrations", to: "/admin/integrations/list", icon: Boxes, perm: "INTEGRATION.VIEW" },
      { label: "Sync Jobs", to: "/admin/integrations/sync-jobs", icon: RefreshCw, perm: "INTEGRATION.VIEW" },
      { label: "Sync Logs", to: "/admin/integrations/sync-logs", icon: ScrollText, perm: "INTEGRATION.VIEW" },
      { label: "Error Log", to: "/admin/integrations/errors", icon: TriangleAlert, perm: "INTEGRATION.VIEW" },
      { label: "Monitoring", to: "/admin/integrations/monitoring", icon: Activity, perm: "INTEGRATION.MONITOR" },
    ],
  },
  {
    group: "Tenant & Org",
    items: [
      { label: "Tenants", to: "/admin/tenants", icon: Building2, perm: "TENANT.VIEW" },
      { label: "Companies", to: "/admin/companies", icon: Building, perm: "COMPANY.VIEW" },
      { label: "Users", to: "/admin/users", icon: Users, perm: "USER.VIEW" },
      { label: "Organization Settings", to: "/admin/organization-settings", icon: Globe, perm: "TENANT.CONFIGURE" },
    ],
  },
  {
    group: "Access Control",
    items: [
      { label: "Roles", to: "/admin/roles", icon: ShieldCheck, perm: "ROLE.VIEW" },
      { label: "Permissions", to: "/admin/permissions", icon: KeyRound, perm: "PERMISSION.VIEW" },
    ],
  },
  {
    group: "Commercial",
    items: [
      { label: "Plans", to: "/admin/plans", icon: CreditCard, perm: "PLAN.VIEW" },
      { label: "Packages", to: "/admin/packages", icon: Package, perm: "PACKAGE.VIEW" },
      { label: "Modules", to: "/admin/modules", icon: Boxes, perm: "MODULE.VIEW" },
      { label: "Features", to: "/admin/features", icon: Puzzle, perm: "FEATURE.VIEW" },
      { label: "Entitlements", to: "/admin/entitlements", icon: ToggleRight, perm: "ENTITLEMENT.VIEW" },
      { label: "Subscriptions", to: "/admin/subscriptions", icon: CreditCard, perm: "SUBSCRIPTION.VIEW" },
      { label: "Usage Governance", to: "/admin/usage", icon: Gauge, perm: "USAGE.VIEW" },
      { label: "Industry Packs", to: "/admin/industry-packs", icon: Factory, perm: "INDUSTRY_PACK.VIEW" },
      { label: "Pack Configuration", to: "/admin/product/pack-configuration", icon: Boxes, perm: "ENTITLEMENT.VIEW" },
      { label: "White Label", to: "/admin/white-label", icon: Palette, perm: "WHITELABEL.VIEW" },
    ],
  },
  {
    group: "Loyalty & Rewards",
    items: [
      { label: "Loyalty Dashboard", to: "/admin/loyalty", icon: Gift, perm: "LOYALTY.VIEW" },
      { label: "Loyalty Programs", to: "/admin/loyalty/programs", icon: Award, perm: "LOYALTY.VIEW" },
      { label: "Reward Rules", to: "/admin/loyalty/rules", icon: Sparkles, perm: "LOYALTY.VIEW" },
      { label: "Membership & Tiers", to: "/admin/loyalty/membership", icon: Crown, perm: "LOYALTY.VIEW" },
      { label: "Referrals", to: "/admin/loyalty/referrals", icon: UserPlus, perm: "LOYALTY.VIEW" },
      { label: "Coupons & Vouchers", to: "/admin/loyalty/coupons", icon: Ticket, perm: "LOYALTY.VIEW" },
      { label: "AI Loyalty Intelligence", to: "/admin/loyalty/ai", icon: BrainCircuit, perm: "LOYALTY.ANALYTICS" },
      { label: "Loyalty Analytics", to: "/admin/loyalty/analytics", icon: PieChart, perm: "LOYALTY.ANALYTICS" },
      { label: "Omnichannel", to: "/admin/loyalty/omnichannel", icon: Split, perm: "LOYALTY.VIEW" },
      { label: "Customer Wallet", to: "/admin/loyalty/wallets", icon: Wallet, perm: "LOYALTY.VIEW" },
      { label: "Transactions", to: "/admin/loyalty/transactions", icon: Coins, perm: "LOYALTY.VIEW" },
      { label: "Loyalty Settings", to: "/admin/loyalty/settings", icon: Settings, perm: "LOYALTY.VIEW" },
    ],
  },
  {
    group: "Growth & Channel",
    items: [
      { label: "Trials", to: "/admin/trials", icon: FlaskConical, perm: "TRIAL.VIEW" },
      { label: "Partners", to: "/admin/partners", icon: Handshake, perm: "PARTNER.VIEW" },
      { label: "Resellers", to: "/admin/resellers", icon: Store, perm: "RESELLER.VIEW" },
    ],
  },
  {
    group: "Platform Governance",
    items: [
      { label: "Notifications", to: "/admin/notifications", icon: Bell, perm: "NOTIFICATION.VIEW" },
      { label: "File Manager", to: "/admin/files", icon: FolderOpen, perm: "FILE.VIEW" },
      { label: "AI Foundation", to: "/admin/ai", icon: BrainCircuit, perm: "AI_CONFIG.VIEW" },
      { label: "System Settings", to: "/admin/settings", icon: Settings, perm: "SETTINGS.VIEW" },
      { label: "Audit Center", to: "/admin/audit", icon: ScrollText, perm: "AUDIT.VIEW" },
    ],
  },
];
